import { BsDownload } from "react-icons/bs";
import ActionButtonWithIcon from "../Common/ActionButtonWithIcon";
import { useTranslation } from "react-i18next";

interface Props {
    onClick: () => void;
    disabled?: boolean;
    isLoading?: boolean;
}

export const DownloadConversationButton = ({ disabled, onClick, isLoading }: Props) => {
    const { t } = useTranslation("translation", { keyPrefix: "chat" });
    return (
        <ActionButtonWithIcon
            text={t("downloadConversation")}
            icon={BsDownload}
            onClick={onClick}
            isLoading={isLoading}
            buttonProps={{ disabled: disabled }}
        />
    );
};
